import { PriceContainer } from '../../containers/filters/PriceContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const price: IOpenableFilter = {
  component: PriceContainer,
  type: EFilterType.Openable,
};
